import { Control, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./Form";
import { Input, InputProps } from "../Input";
import { cn } from "../../../utils";
import {
  formInputClassName,
  inputClassName as baseInputClassName,
  labelClassName,
  SvgButton,
} from "../../..";
import { useState } from "react";

type FormPasswordInputProps<TForm extends FieldValues> = {
  control: Control<TForm>;
  name: Path<TForm>;
  label: string;
  hasMessage?: boolean;
  errorRing?: boolean;
  inputClassName?: string;
} & InputProps;

export function FormPasswordInput<TForm extends FieldValues>({
  control,
  name,
  label,
  hasMessage = false,
  errorRing = true,
  inputClassName,
  ...props
}: FormPasswordInputProps<TForm>) {
  const [showPassword, setShowPassword] = useState(false);

  function changePasswordVisibility(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    event.preventDefault();
    setShowPassword((prev) => !prev);
  }

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={cn(formInputClassName, props.className)}>
          {label && label.length > 0 ? (
            <FormLabel className={labelClassName}>{label}</FormLabel>
          ) : null}

          <div className="relative">
            <FormControl>
              <Input
                {...field}
                {...props}
                className={cn(baseInputClassName, inputClassName, {
                  "ring-destructive focus-visible:ring-destructive focus-visible:ring-offset-background ring-1 focus-visible:ring-offset-1":
                    fieldState.error,
                })}
                type={showPassword ? "text" : "password"}
              />
            </FormControl>
            <SvgButton
              name={showPassword ? "eye_slash" : "eye"}
              alt="eye icon"
              onClick={changePasswordVisibility}
              type="button"
              className="absolute right-5 top-2.5 size-4"
            />
          </div>
          {hasMessage ? <FormMessage /> : null}
        </FormItem>
      )}
    />
  );
}

export default FormPasswordInput;
